export const {
  PUBLIC_URL,
  REACT_APP_API_BASE_URL,
  REACT_APP_API_AUTH_URL,
  REACT_APP_BASE_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_GOOGLE_ANALYTICS_KEY = null,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION = null,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY = null,
  REACT_APP_HOTJAR_ID = null,
  REACT_APP_HOTJAR_SNIPPET_VERSION = null,
  REACT_APP_FIRTS_NUMBER,
  REACT_APP_SECOND_NUMBER,
  REACT_APP_SECOND_PRIVATE_NUMBER,
  REACT_APP_CENTROAYUDA_BASE_URL,
  REACT_APP_TERMS_AND_CONDITIONS_URL,
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_ACCESS_TOKEN_NAME_MP,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local'
